<template>
  <OnClickOutside
    class="endless-filter-list-wrap"
    @trigger="handleClickOutside"
  >
    <div v-if="!hideSearch" class="ais-RefinementList-searchBox">
      <form class="ais-SearchBox-form">
        <input
          ref="searchInput"
          v-model="searchForFacetValues"
          class="ais-SearchBox-input"
          :aria-label="jobSearchGlobal.config.filters.placeholderText"
          :placeholder="jobSearchGlobal.config.filters.placeholderText"
        />
        <button
          type="reset"
          class="ais-SearchBox-reset"
          :hidden="!searchForFacetValues"
          @click="resetSearch"
        >
          <slot name="reset-icon">
            <svg
              aria-hidden="true"
              height="10"
              viewBox="0 0 20 20"
              class="ais-SearchBox-resetIcon"
              width="10"
            >
              <path
                d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
              />
            </svg>
          </slot>
        </button>
      </form>
    </div>

    <slot
      v-if="isFromSearch && items.length === 0"
      name="noResults"
      :query="searchForFacetValues"
    >
      <p class="search-filter-refinement-empty-state">
        {{ jobSearchGlobal.config.filters.emptyStateText }}
      </p>
    </slot>

    <ul v-if="items.length > 0" class="ais-RefinementList-list">
      <li
        v-for="item in paginatedItems"
        :key="item.value"
        :class="[
          'ais-RefinementList-item',
          item.isRefined &&
            ('ais-RefinementList-item', 'ais-RefinementList-item--selected'),
        ]"
      >
        <slot
          name="item"
          :item="item"
          :refine="refine"
          :create-u-r-l="createURL"
        >
          <label class="ais-RefinementList-label">
            <input
              class="ais-RefinementList-checkbox"
              type="checkbox"
              :value="item.value"
              :checked="item.isRefined"
              @change="handleRefine(refine, item.value)"
            />
            <span
              class="ais-RefinementList-labelText"
              v-html="item.highlighted"
            ></span>

            <span class="ais-RefinementList-count">{{ item.count }}</span>
          </label>
        </slot>
      </li>
      <span ref="trigger" class="endless-scroll-trigger" />
    </ul>
  </OnClickOutside>
</template>

<script>
import { OnClickOutside } from "@vueuse/components";

export default {
  name: "EndlessFilterList",
  components: { OnClickOutside },
  props: {
    attribute: {
      type: String,
      required: true,
    },
    defaultSize: {
      type: Number,
      default: 20,
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isFromSearch: {
      type: Boolean,
    },
    refine: {
      type: Function,
      default: () => {},
    },
    createURL: {
      type: Function,
      default: () => {},
    },
    searchForItems: {
      type: Function,
      default: () => {},
    },
    sendEvent: {
      type: Function,
      default: () => {},
    },
    jobSearchGlobal: {
      type: Object,
      default: () => {},
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchForFacetValuesQuery: "",
      paginationSize: this.defaultSize,
      observer: null,
    };
  },
  computed: {
    paginatedItems() {
      return this.items.slice(0, this.paginationSize);
    },
    searchForFacetValues: {
      get() {
        return this.searchForFacetValuesQuery;
      },
      set(value) {
        this.paginationSize = this.defaultSize;
        this.searchForItems(value);
        this.searchForFacetValuesQuery = value;
      },
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(() => {
      this.showMore();
    });

    // wait for refs to be set
    const setObserverInterval = setInterval(() => {
      if (this.$refs.trigger) {
        this.observer.observe(this.$refs.trigger);
        clearInterval(setObserverInterval);
      }
    }, 50);
  },
  unmounted() {
    this.observer.disconnect();
  },
  methods: {
    showMore() {
      this.paginationSize += this.defaultSize;
    },
    resetSearch() {
      this.searchForFacetValues = "";
    },
    handleRefine(refine, value) {
      refine(value);

      setTimeout(() => {
        if (this.$refs.searchInput) {
          this.searchForFacetValues = this.$refs.searchInput.value;

          const keyEvent = new KeyboardEvent("keydown", {
            key: "Space",
            code: "Space",
            keyCode: 32,
            which: 32,
          });
          this.$refs.searchInput.dispatchEvent(keyEvent);
        }
      }, 300);
    },
    handleClickOutside() {
      this.resetSearch();
    },
  },
};
</script>
<style lang="scss" scoped>
.endless-filter-list-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 25px;
}

.endless-scroll-trigger {
  display: block;
  height: 1px;
}
</style>
